import { createAction, props } from '@ngrx/store';
import { BagItems, IUtilitReducer } from '../models/utility-reducer.interface';
import { PostOffice } from '../../booking/models/hubdrop.interface';

// Action types
export const isDiamondAirline = createAction(
  '[Utility] Is Diamond Airline',
  props<{ payload: boolean }>()
);

export const isBookingHubdropBooking = createAction(
  '[Utility] Is Booking Hubdrop Booking',
  props<{ payload: boolean }>()
);

export const updateAmendZoneId = createAction(
  '[Utility] Update Amend Zone ID',
  props<{ payload: string }>()
);

export const setSelectedPostOffice = createAction(
  '[Utility] Set Selected Post Office',
  props<{ payload: PostOffice }>()
);

export const refreshUtilityReducer = createAction(
  '[Utility] Refresh Utility Reducer',
  props<{ payload: IUtilitReducer }>()
);

export const resetUtilityReducer = createAction(
  '[Utility] Reset Utility Reducer'
);

export const setCurrentBagItems = createAction(
  '[Utility] Set Current Bag Items',
  props<{ payload: BagItems }>()
);
